import { render } from "./sidebarUserProfile.vue?vue&type=template&id=73f4a547"
import script from "./sidebarUserProfile.vue?vue&type=script&lang=js"
export * from "./sidebarUserProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__